import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, Button, Typography, Space, Result } from "antd";

const { Title } = Typography;

export default function AuthErrorPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error") || "An authentication error occurred";

  const getErrorMessage = (error: string): string => {
    switch (error) {
      case "AccessDenied":
        return "You do not have permission to access this application.";
      case "Verification":
        return "The verification link may have expired. Please try signing in again.";
      case "Configuration":
        return "There is a problem with the authentication configuration.";
      case "Callback":
        return "There was an error during the authentication callback.";
      default:
        return "An unexpected error occurred during authentication. Please try again.";
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#F8F7F5",
        padding: 24,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          marginBottom: 32,
        }}
      >
        <img
          src="/secondary-logo-gradient.png"
          alt="AIXA"
          style={{ width: 40, height: 40, objectFit: "contain" }}
        />
        <Title level={2} style={{ margin: 0, color: "#0F6E56", letterSpacing: "0.5px" }}>
          AIXA <span style={{ fontWeight: 400 }}>Share</span>
        </Title>
      </div>

      <Card
        style={{
          maxWidth: 500,
          width: "100%",
          borderRadius: 12,
          boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
        }}
      >
        <Result
          status="error"
          title="Authentication Error"
          subTitle={getErrorMessage(error)}
          extra={
            <Space>
              <Button type="primary" onClick={() => navigate("/auth/signin")}>
                Try Again
              </Button>
              <Button onClick={() => navigate("/")}>
                Go Home
              </Button>
            </Space>
          }
        />
      </Card>
    </div>
  );
}
